import { InputPicker } from "rsuite";
import { frontDB } from "../../../../../frontDB";
import styles from "./SyncLogsHeader.module.css";
import { useSyncLogsHeader } from "./useSyncLogsHeader";
import { useEffect } from "react";
import { showActive } from "../../../../../helperFunctions";
import moment from "moment";
function SyncLogsHeader() {
  let { locations, location } = frontDB();

  let {
    filter,
    locationHandler,
    setSelectedLocation,
    saveToOfficeStatusHandler,
    getLatestSyncLogs,
    latestSyncLogs,
  } = useSyncLogsHeader();

  useEffect(() => {
    setSelectedLocation();
    getLatestSyncLogs();
  }, [location]);

  // Only active
  locations = showActive(locations);

  let locationOptions = [
    { label: "All vessels", value: "*" },
    ...locations
      .filter((location) => location.name != "Office")
      .map((item) => ({ label: item.name, value: item._id })),
  ];

  let saveToOfficeStatusOptions = [
    { label: "All statuses", value: "*" },
    { label: "Success", value: "success" },
    { label: "Error", value: "error" },
  ];

  const getColor = (date) => {
    const hoursDiff = moment().diff(moment(date), "hours");
    if (hoursDiff > 24) return "red";
    if (hoursDiff > 12) return "#0d00ff";
    return "green";
  };

  const renderLogs = (logs) =>
    logs.map((log) => (
      <div style={{ fontSize: 11 }} key={log.locationName}>
        {log.locationName}:{" "}
        <span
          style={{
            color: getColor(log?.updateTillDate),
            fontSize: 10,
          }}
        >
          {moment(log?.updateTillDate).utc().format("D/MM/YYYY HH:mm")}{" "}
          {log?.syncType === "manual" ? "M" : "A"}
        </span>
      </div>
    ));

  //! Render
  return (
    <>
      <div className={styles.counters_header}>
        <div className={styles.counters_header_title}>Sync Logs</div>

        <div className={styles.filter_options}>
          <div className={styles.filter_options_select}>
            <InputPicker
              value={filter?.locationId}
              onChange={locationHandler}
              cleanable={false}
              placeholder="Select vessel"
              data={locationOptions}
              style={{ width: 224 }}
            />
            <InputPicker
              value={filter?.saveToOffice}
              onChange={saveToOfficeStatusHandler}
              cleanable={false}
              placeholder="Select status"
              data={saveToOfficeStatusOptions}
              style={{ width: 224 }}
            />
          </div>

          <div className={styles.latestsync_container}>
            {renderLogs(latestSyncLogs.slice(0, 5))}
          </div>
          <div className={styles.latestsync_container}>
            {renderLogs(latestSyncLogs.slice(5))}
          </div>
        </div>
      </div>
    </>
  );
}

export default SyncLogsHeader;
